/* unplugin-vue-components disabled */import { defineComponent, // ref,
// watch,
computed } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    components: {},
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 24
        },
        icon: {
            type: definePropType([
                String,
                Object
            ]),
            default: ""
        },
        label: {
            type: String
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        IcAdd;
        var handleClick = function() {
            if (props.disabled) return;
            console.log("handleClick");
            emit("click");
        };
        var buttonAttr = computed(function() {
            return {
                height: "".concat(props.size, "px")
            };
        });
        return {
            handleClick: handleClick,
            buttonAttr: buttonAttr
        };
    }
});
